var _clipPath, _clipPath2, _clipPath3, _clipPath4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 0h400v300h-400z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 300h400v179.996h-400z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 300h400v179.996h-400z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m440 50c0-27.6133-22.383-50-50-50h-300c-27.6172 0-50 22.3867-50 50v380c0 27.613 22.3828 50 50 50h240l110-110z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.13333333 0 0 -.13333333 0 64)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.813 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6133 22.3828-50 50-50h300c27.617 0 50 22.3867 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0547-17.937-40-40-40h-300c-22.0586 0-40 17.9453-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#d8d8d8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m357.5 150h-135c-8.281 0-15 6.715-15 15s6.719 15 15 15h135c8.281 0 15-6.715 15-15s-6.719-15-15-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.5 90h-135c-8.281 0-15 6.7148-15 15 0 8.285 6.719 15 15 15h135c8.281 0 15-6.715 15-15 0-8.2852-6.719-15-15-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.5 210h-245c-8.281 0-15 6.715-15 15s6.719 15 15 15h245c8.281 0 15-6.715 15-15s-6.719-15-15-15"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90 5c-24.8164 0-45 20.1875-45 45v380c0 24.816 20.1836 45 45 45h237.93l107.07-107.07v-317.93c0-24.8125-20.187-45-45-45z",
    fill: "#d84953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330 480h-240c-27.6172 0-50-22.387-50-50v-380c0-27.6133 22.3828-50 50-50h300c27.617 0 50 22.3867 50 50v320zm-4.141-10 104.141-104.141v-315.859c0-22.0547-17.937-40-40-40h-300c-22.0586 0-40 17.9453-40 40v380c0 22.055 17.9414 40 40 40z",
    fill: "#c4434c"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m344.355 384.973 96.79-96.793v96.793z",
    fill: "#c4434c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m440 370h-60c-27.617 0-50 22.387-50 50v60h110z",
    fill: "#eca4a9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m108.281 407.328v-14.765h4.832c2.082 0 3.86.746 5.344 2.242 1.477 1.492 2.219 3.265 2.219 5.316 0 2.344-.832 4.16-2.512 5.449-1.66 1.289-4.043 1.934-7.109 1.934zm-12.1677 10.371h19.7267c5.305 0 9.582-1.547 12.832-4.633 3.254-3.093 4.883-7.156 4.883-12.199 0-3.308-.801-6.453-2.403-9.422-1.601-2.976-4.004-5.195-7.226-6.66-3.223-1.465-5.977-2.226-8.262-2.285l-7.207-.176v-22.324h-12.3437z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.879 406.801v-35.641h4.922c5.097 0 9.277 1.395 12.558 4.176 3.282 2.785 4.922 7.43 4.922 13.934 0 3.777-.781 7.121-2.363 10.035-1.582 2.918-3.887 4.894-6.875 5.937-3.008 1.039-5.879 1.559-8.594 1.559zm-12.527 10.898h19.683c8.41 0 15.18-2.652 20.305-7.953 5.129-5.301 7.695-12.289 7.695-20.961 0-8.703-2.656-15.676-7.93-20.918-5.292-5.246-12.335-7.867-21.125-7.867h-18.628z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m200.828 417.699h32.473v-11.16h-20.117v-11.777h20.117v-11.25h-20.039v-23.512h-12.434z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180 105c0-8.2852-6.719-15-15-15h-50c-8.281 0-15 6.7148-15 15v60c0 8.285 6.719 15 15 15h50c8.281 0 15-6.715 15-15z",
    fill: "#e0e0e0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9c5e1259ecd9e43fef2c065a73e6c3ca.svg";
export { ForwardRef as ReactComponent };